import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

export const deleteWeatherStation = (stationId: number) => {
  return axios.delete(`/api/weather/stations/${stationId}`);
};

type UseDeleteWeatherStationOptions = {
  config?: MutationConfig<typeof deleteWeatherStation>;
};

export const useDeleteWeatherStation = ({
  config,
}: UseDeleteWeatherStationOptions) => {
  return useMutation({
    onError: (_, __, context: any) => {
      if (context?.previousWeatherStations) {
        queryClient.setQueryData(
          ['weatherStations'],
          context.previousWeatherStations
        );
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['weatherStations']);
    },
    ...config,
    mutationFn: deleteWeatherStation,
  });
};
